import storage from '../storage/storage';
import { SESSION_ID_STORAGE_KEY } from '../conf';
import { env } from '../env';

const sessionManager = {
  getSessionId() {
    let res =
      typeof env() !== 'undefined' && env().fedops && env().fedops.sessionId;

    res = res || storage.getItem(SESSION_ID_STORAGE_KEY);
    res = res || this.generateGuid();

    storage.setItem(SESSION_ID_STORAGE_KEY, res);
    return res;
  },

  generateGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8); // eslint-disable-line
      return v.toString(16);
    });
  },
};

export default sessionManager;
